module.exports = __webpack_public_path__ + "static/media/Island-Lake-Shores-North-bylaws.1ff79186.pdf";